// extracted by css-extract-rspack-plugin
export default {"EntityViewSwitchRoot":"DrYwH"};